import {
  EDIT_EMAIL_LOGIN, EDIT_PASSWORD, RESET_LOGIN_FORM, LOGIN_BUTTON_SWITCH
} from "../actions/login_form_actions"


const initialState = {
  email: '',
  password: '',
  button_disabled: true
}

export const loginFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case EDIT_EMAIL_LOGIN: {
      return {
        ...state,
        email: action.email
      }
    }
    case EDIT_PASSWORD: {
      return {
        ...state,
        password: action.password
      }
    }
    case LOGIN_BUTTON_SWITCH: {
      return {
        ...state,
        button_disabled: action.button_disabled
      }
    }
    case RESET_LOGIN_FORM: {
      return {
        ...state,
        email: '',
        password: ''
      }
    }
    default: return state;
  }
}
